




















import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  MentoringMember,
  MentoringAvatar,
} from '@/pages/profile/modules/mentoring/components';
import { IMentoringTeamCardMentor } from './types';

@Component({
  components: {
    MentoringMember,
    MentoringAvatar,
  },
})
export default class MentoringCrew
  extends Vue
  implements IMentoringTeamCardMentor {
  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: String, default: '' })
  readonly lastname!: string;

  @Prop({ type: String, default: '' })
  readonly email!: string;

  @Prop({ type: String, default: '' })
  readonly phone!: string;

  @Prop({ type: String, default: '' })
  readonly image!: string;

  @Prop({ type: String, default: 'N' })
  readonly gender!: string;

  @Prop({ type: String, default: 'mentor' })
  readonly type!: string;

  get typeText(): string {
    return this.type === 'mentor' ? 'Наставник' : 'Куратор';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/teamcard/components/mentor/MentoringTeamCardMentor.vue